<template>
  <div class="px-10 flex items-center py-[100px]">
    <div
      class="
        left-[89px]
        text-center
        absolute
        top-0
        mt-[100px]
        text-white
        w-full
      "
    >
      Select One
    </div>
    <div>
      <button
        @click="bisMe"
        class="
          w-full
          focus:outline-none
          rounded-md
          text-white
          mt-2
          bg-gray-400
          h-[26px]
          fontBtn
        "
      >
        The property is under my name.
      </button>
      <button
        @click="bisCo"
        class="
          w-full
          focus:outline-none
          rounded-md
          text-white
          mt-2
          bg-gray-400
          h-[26px]
          fontBtn
        "
      >
        The property is under a company.
      </button>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    bisMe() {
      this.$router.push({ name: "My Buyer's Information Sheet" });
    },
    bisCo() {
      this.$router.push({ name: "Co Buyer's Information Sheet" });
    },
  },
};
</script>

<style scoped>
.btnSelection:hover {
  background: linear-gradient(0deg, rgb(194, 93, 5), red);
}
.btnSelection {
  background: linear-gradient(0deg, #8fbc8f, #2f4f4f);
}
</style>